import { useState } from 'react';

import { ampli } from '~shared/analytics';

import { lastOtpRequestPhoneAtom } from '@breezeventures/web-ph-client-auth/model';
import { useAtomValue } from 'jotai';

import { OtpScreen } from './otp-screen';
import { PhoneScreen } from './phone-screen';

import { useUserPhone } from '../../model';

// TODO: remove in a few weeks after release
const migrateLocalStoragePhone = () => {
  try {
    const phoneV1 = localStorage.getItem('merchant_dashboard_phone');
    const phoneV2 = localStorage.getItem(
      'customer_profile_last_confirmed_phone_number'
    );

    if (phoneV1 && !phoneV2) {
      localStorage.setItem(
        'customer_profile_last_confirmed_phone_number',
        phoneV1
      );
      localStorage.removeItem('merchant_dashboard_phone');
      ampli.client.track('mp_old_phone_restored');
      return JSON.parse(phoneV1);
    }
  } catch (_e) {
    //
  }

  return null;
};

export const LoginPage = () => {
  const [step, setStep] = useState<'phone' | 'otp'>('phone');
  const [phoneNumber, setPhoneNumber] = useState('');

  const lastOtpRequestPhone = useAtomValue(lastOtpRequestPhoneAtom);
  const lastConfirmedPhone = useUserPhone();
  const initialPhone =
    migrateLocalStoragePhone() ?? lastOtpRequestPhone ?? lastConfirmedPhone;

  const setPhoneStep = () => {
    setStep('phone');
  };

  const setOtpStep = () => {
    setStep('otp');
  };

  if (step === 'phone') {
    return (
      <PhoneScreen
        initialPhone={initialPhone}
        onSubmit={(values) => {
          ampli.mpAuthPhoneScreenGetCodeClick({ phone: values.phone });
          setPhoneNumber(values.phone);
          setOtpStep();
        }}
      />
    );
  }

  return (
    <OtpScreen
      onBack={() => {
        setPhoneStep();
        ampli.mpAuthOtpScreenBackClick({ phone: phoneNumber });
      }}
      phoneNumber={phoneNumber}
    />
  );
};
